// Marker error for the wizard's registered-save contract (wp8 fix-forward
// list, 2026-08-21: "dup error-banner on failed step save").
//
// The contract: a step body's registered save() re-throws on failure so the
// shell (routes/setup.tsx) blocks Continue's advance. But two bodies
// (BusinessInfoPanel, SearchTermsBlock) ALSO render their own specific
// inline error copy ("capacity", "identity_missing", ...) before
// re-throwing — and the shell's catch used to add its generic "couldn't
// save this step — try again" banner on top, so the owner saw TWO error
// messages for one failure.
//
// A body that has ALREADY displayed its own error wraps the rejection in
// HandledSaveError; the shell still blocks the advance but skips its
// generic banner. A body that displays nothing of its own (Reputation/
// Pulse's bare prefs PATCH) keeps throwing plain errors and gets the
// shell's banner as before — every failure shows exactly ONE message.
export class HandledSaveError extends Error {
  constructor(cause: unknown) {
    super('step_save_failed_and_displayed', { cause });
    this.name = 'HandledSaveError';
  }
}

export function isHandledSaveError(err: unknown): err is HandledSaveError {
  return err instanceof HandledSaveError;
}
